/**
 * 카카오 API 연동 주소찾기 + 좌표반환
 * 
 */

const KakaoApiMixin = {

  mounted() {
  },

  methods: {
    kakaoAddr(callbackFunc, my_element = false) {

      let kakaoApiSetting = {
        // width: width, //생성자에 크기 값을 명시적으로 지정해야 합니다.
        // height: height,
        oncomplete: (data) => {
          // console.log(data)
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

          // // 도로명 주소의 노출 규칙에 따라 주소를 조합한다.
          // // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          // let fullRoadAddr = data.roadAddress; // 도로명 주소 변수
          // let extraRoadAddr = ''; // 도로명 조합형 주소 변수

          // // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          // if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
          //   extraRoadAddr += data.bname;
          // }
          // // 건물명이 있고, 공동주택일 경우 추가한다.
          // if (data.buildingName !== '' && data.apartment === 'Y') {
          //   extraRoadAddr += (extraRoadAddr !== '' ? ', ' + data.buildingName : data
          //     .buildingName);
          // }
          // // 도로명, 지번 조합형 주소가 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          // if (extraRoadAddr !== '') {
          //   extraRoadAddr = ' (' + extraRoadAddr + ')';
          // }
          // // 도로명, 지번 주소의 유무에 따라 해당 조합형 주소를 추가한다.
          // if (fullRoadAddr !== '') {
          //   fullRoadAddr += extraRoadAddr;
          // }

          // 각 주소의 노출 규칙에 따라 주소를 조합한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          var addr = ''; // 주소 변수
          var extraAddr = ''; // 참고항목 변수

          //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
          if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
          } else { // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
          }

          // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
          if (data.userSelectedType === 'R') {
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
              extraAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if (data.buildingName !== '' && data.apartment === 'Y') {
              extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data
                .buildingName);
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if (extraAddr !== '') {
              extraAddr = ' (' + extraAddr + ')';
            }
          }

          
          // 우편번호와 주소 정보를 해당 필드에 넣는다.
          let returnData = {
            zoneCode: data.zonecode,
            sigunguCode: data.sigunguCode,
            addr: addr + extraAddr
            // addr: fullRoadAddr,
          }
          
          callbackFunc(returnData);
        }
      }
      


      if(my_element) {
        new window.daum.Postcode(kakaoApiSetting).embed(my_element);
      } else {
        // let width = 500;
        // let height = 500;
        new window.daum.Postcode(kakaoApiSetting).open({
          // left: (window.screen.width / 2) - (width / 2),
          // top: (window.screen.height / 2) - (height / 2)
        });
      }
    },
    
    kakaoCoords(addr, callbackFunc) {
      var geocoder = new window.kakao.maps.services.Geocoder();
      geocoder.addressSearch(addr, function (result, status) {
        // 정상적으로 검색이 완료됐으면 
        if (status === window.kakao.maps.services.Status.OK) {

          var coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
          // console.log(coords)
          let returnData = {
            lat:coords.Ma.toFixed(5),
            har:coords.La.toFixed(5),
          }

          callbackFunc(returnData)
        }
      });
    },

    // setKakaoMap() {
    //   var container = document.createElement('div');
    //   var options = { //지도를 생성할 때 필요한 기본 옵션
    //     center: new window.kakao.maps.LatLng(33.450701, 126.570667), //지도의 중심좌표.
    //     // center: new kakao.maps.LatLng(this.lat, this.har), //지도의 중심좌표.
    //     level: 4 //지도의 레벨(확대, 축소 정도)
    //   };

    //   this.map = new window.kakao.maps.Map(container, options); //지도 생성 및 객체 리턴
    // },
  }
};


export {
  KakaoApiMixin
}